import { render, staticRenderFns } from "./QuickTipsSharedIdGroupDetails.vue?vue&type=template&id=0be0ff98&scoped=true&"
import script from "./QuickTipsSharedIdGroupDetails.vue?vue&type=script&lang=js&"
export * from "./QuickTipsSharedIdGroupDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be0ff98",
  null
  
)

export default component.exports